import axios from "axios";

// Production API URL
export const API_BASE_URL = "https://api.asianpublisher.in";

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const REACT_APP_URL = API_BASE_URL;
